import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { typeOfService } from "./api-interfaces/typeOfService.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIService {
    ApiURL: string = "";
    constructor(private http: HttpClient,public helperService: HelperService) {
        this.ApiURL = environment.servicesURL + 'Services/';
    }

    public get(serviceId: string): Observable<typeOfService[]>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
       
            return this.http.get<typeOfService[]>(this.ApiURL + encodeURIComponent(serviceId),requestOptions);
       
    }
    public getworkshopAndbrand(workshopId:number): Observable<any>{
        
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        
        return this.http.get(this.ApiURL + 'workshop/'+ encodeURIComponent(workshopId),requestOptions);}

    public getAdvisorAndbrand(AdvisorId:number): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.get(this.ApiURL + 'advisor/'+ encodeURIComponent(AdvisorId),requestOptions);}

    
    public getAdvisorServicesForServiceAdvisorRol(AdvisorId:number): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.get(this.ApiURL + 'advisorforschedule/'+ encodeURIComponent(AdvisorId),requestOptions);
    }

    public post(typeOfService:typeOfService): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.post<any>(this.ApiURL,typeOfService,requestOptions )

    }
   
    public put(data): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.put<any>(this.ApiURL, data,requestOptions)
    }

    public delete(id: number):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        let apiURL = `${this.ApiURL}${id}`;
        return this.http.delete(apiURL,requestOptions)
    }
}